import { gql } from "@apollo/client";

const AnnualReportQueryEn = gql`
query MyQuery {
  nodeAnnualReports(first: 100) {
    nodes {
      title
      path
      created {
        time
      }
      id
      __typename
      bannerImage {
        url
        alt
      }
      annualReportSection {
        ... on ParagraphAnnualReportPdf {
          id
          annualReportFile {
            ... on MediaDocument {
              id
              name
              mediaDocument {
                url
                size
                name
                mime
              }
            }
          }
          pdfCoverImage {
            ... on MediaAnnualReportCoverImage {
              id
              name
              mediaImage3 {
                alt
                url
                title
              }
            }
          }
          titleOfPdf
        }
      }
    }
  }
}
`;
export default AnnualReportQueryEn;